import React from 'react'
import withComponentBase from '../helpers/with-component-base'
import { moduleEntity } from '../helpers/modules'
import { RichText, EVEntry } from '../helpers/react'
import { useEntity } from '../helpers/selectors'
import Image from '../imgix-img'

const HeroFlex = (contents) => {
  const { primary, secondary, tertiary, image, showImageOnMobile, imagePosition } = contents
  const primaryComponent = primary && <RichText content={primary} />
  const secondaryComponent = secondary && <EVEntry {...moduleEntity(secondary)} />
  const tertiaryComponent = tertiary && <EVEntry {...moduleEntity(tertiary)} />
  const imageEntity = image && useEntity(image)

  return (
    <div className='HeroFlex'>
      <div className='HeroFlex__primary'>{primaryComponent}</div>
      <div className='HeroFlex__secondary'>{secondaryComponent}</div>
      <div className='HeroFlex__tertiary'>{tertiaryComponent}</div>

      {imageEntity && (
        <div
          className={`HeroFlex${
            !showImageOnMobile ? '__imageContainerDesktopOnly' : '__imageContainer'
          }`}
        >
          <Image
            className={imagePosition}
            src={imageEntity?.file?.url}
            alt={imageEntity?.title}
            critical={true}
            width={500}
          />
        </div>
      )}
    </div>
  )
}

export default withComponentBase(HeroFlex, {
  withHeaderFooter: true,
})
